/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Org_Contract_Approved_ByInputs */



/**
* | output |
* | --- |
* | "Approved {date}" |
*
* @param {Partner_Org_Contract_Approved_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_approved_by = /** @type {((inputs: Partner_Org_Contract_Approved_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Approved_ByInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Freigegeben am ${i?.date}`)
	return /** @type {LocalizedString} */ (`Approved ${i?.date}`)
});